'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompanyLogo = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCompanyLogo = exports.getCompanyLogo = (0, _getIn2.default)(_keyPaths.COMPANY_LOGO);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/operators/getCompanyLogo.js
// module id = 1030
// module chunks = 2 3